import GeminiLoaders from "../../assets/animations/Gemini.json";
import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";

export const GeminiLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        top: 0,
        left: 0,
        zIndex: 9999,
        position: "fixed",
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Lottie
          animationData={GeminiLoaders}
          loop={true}
          style={{ height: "300px", width: "300px" }}
        />
      </div>
    </Box>
  );
};
